import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { createAction } from '../../interfaces';
import * as definitions from '../../definitions/session';
import sessionService from '../../services/session';
import { getErrorMessageFromErrorResponse, handleErrorResponse } from '../../utils/error';
export var sessionActionCreators = {
  createActivityRequest: function createActivityRequest(activity) {
    return createAction(definitions.CREATE_ACTIVITY_REQUEST, activity);
  },
  createActivitySuccess: function createActivitySuccess(activity) {
    return createAction(definitions.CREATE_ACTIVITY_SUCCESS, activity);
  },
  createActivityFail: function createActivityFail(error) {
    return createAction(definitions.CREATE_ACTIVITY_FAIL, error);
  },
  clearSessionErrors: function clearSessionErrors() {
    return createAction(definitions.CLEAR_SESSION_ERRORS);
  },
  setSessionInfo: function setSessionInfo(info) {
    return createAction(definitions.SET_SESSION_INFO, info);
  },
  clearSessionInfo: function clearSessionInfo() {
    return createAction(definitions.CLEAR_SESSION_INFO);
  },
  clearSessionData: function clearSessionData() {
    return createAction(definitions.CLEAR_SESSION_DATA);
  },
  setActivityLocation: function setActivityLocation(location) {
    return createAction(definitions.SET_ACTIVITY_LOCATION, location);
  },
  getActivitiesRequest: function getActivitiesRequest(payload) {
    return createAction(definitions.GET_ACTIVITIES_REQUEST, payload);
  },
  getActivitiesSuccess: function getActivitiesSuccess(activities) {
    return createAction(definitions.GET_ACTIVITIES_SUCCESS, activities);
  },
  getActivitiesFail: function getActivitiesFail(error) {
    return createAction(definitions.GET_ACTIVITIES_FAIL, error);
  },
  deleteActivityRequest: function deleteActivityRequest() {
    return createAction(definitions.DELETE_ACTIVITY_REQUEST);
  },
  deleteActivitySuccess: function deleteActivitySuccess(activityId) {
    return createAction(definitions.DELETE_ACTIVITY_SUCCESS, {
      id: activityId
    });
  },
  deleteActivityFail: function deleteActivityFail(error) {
    return createAction(definitions.DELETE_ACTIVITY_FAIL, error);
  },
  updateActivityRequest: function updateActivityRequest() {
    return createAction(definitions.UPDATE_ACTIVITY_REQUEST);
  },
  updateActivitySuccess: function updateActivitySuccess(activity) {
    return createAction(definitions.UPDATE_ACTIVITY_SUCCESS, activity);
  },
  updateActivityFail: function updateActivityFail(error) {
    return createAction(definitions.UPDATE_ACTIVITY_FAIL, error);
  },
  createSessionRequest: function createSessionRequest() {
    return createAction(definitions.CREATE_SESSION_REQUEST);
  },
  createSessionSuccess: function createSessionSuccess(session) {
    return createAction(definitions.CREATE_SESSION_SUCCESS, session);
  },
  createSessionFail: function createSessionFail(error) {
    return createAction(definitions.CREATE_SESSION_FAIL, error);
  },
  updateSessionRequest: function updateSessionRequest() {
    return createAction(definitions.UPDATE_SESSION_REQUEST);
  },
  updateSessionSuccess: function updateSessionSuccess(session) {
    return createAction(definitions.UPDATE_SESSION_SUCCESS, session);
  },
  updateSessionFail: function updateSessionFail(error) {
    return createAction(definitions.UPDATE_SESSION_FAIL, error);
  },
  getSessionRequest: function getSessionRequest() {
    return createAction(definitions.GET_SESSION_REQUEST);
  },
  getSessionSuccess: function getSessionSuccess(session) {
    return createAction(definitions.GET_SESSION_SUCCESS, session);
  },
  getSessionFail: function getSessionFail(error) {
    return createAction(definitions.GET_SESSION_FAIL, error);
  },
  getActivityRequest: function getActivityRequest() {
    return createAction(definitions.GET_ACTIVITY_REQUEST);
  },
  getActivitySuccess: function getActivitySuccess(activity) {
    return createAction(definitions.GET_ACTIVITY_SUCCESS, activity);
  },
  getActivityFail: function getActivityFail(error) {
    return createAction(definitions.GET_ACTIVITY_FAIL, error);
  },
  getSessionAccessRequest: function getSessionAccessRequest() {
    return createAction(definitions.GET_SESSION_ACCESS_REQUEST);
  },
  getSessionAccessSuccess: function getSessionAccessSuccess(entitlementCheck) {
    return createAction(definitions.GET_SESSION_ACCESS_SUCCESS, entitlementCheck);
  },
  getSessionAccessFail: function getSessionAccessFail(error) {
    return createAction(definitions.GET_SESSION_ACCESS_FAIL, error);
  },
  getUpcomingSessionsRequest: function getUpcomingSessionsRequest() {
    return createAction(definitions.GET_UPCOMING_SESSIONS_REQUEST);
  },
  getUpcomingSessionsSuccess: function getUpcomingSessionsSuccess(sessions) {
    return createAction(definitions.GET_UPCOMING_SESSIONS_SUCCESS, sessions);
  },
  getUpcomingSessionsFail: function getUpcomingSessionsFail(error) {
    return createAction(definitions.GET_UPCOMING_SESSIONS_FAIL, error);
  },
  setCurrentSession: function setCurrentSession(event) {
    return createAction(definitions.SET_CURRENT_SESSION, event);
  }
};
export var clearSessionData = function clearSessionData() {
  return function (dispatch) {
    var clearSessionDataAction = sessionActionCreators.clearSessionData;
    dispatch(clearSessionDataAction());
  };
};
export var createActivity = function createActivity(payload) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var createActivityRequest, createActivitySuccess, createActivityFail;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              createActivityRequest = sessionActionCreators.createActivityRequest, createActivitySuccess = sessionActionCreators.createActivitySuccess, createActivityFail = sessionActionCreators.createActivityFail;
              dispatch(createActivityRequest(payload));
              return _context.abrupt("return", sessionService.createActivity(payload).then(function (activity) {
                dispatch(createActivitySuccess(activity));
                return activity;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createActivityFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var deleteActivity = function deleteActivity(activityId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch) {
      var deleteActivityRequest, deleteActivitySuccess, deleteActivityFail;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              deleteActivityRequest = sessionActionCreators.deleteActivityRequest, deleteActivitySuccess = sessionActionCreators.deleteActivitySuccess, deleteActivityFail = sessionActionCreators.deleteActivityFail;
              dispatch(deleteActivityRequest());
              return _context2.abrupt("return", sessionService.deleteActivity(activityId).then(function () {
                dispatch(deleteActivitySuccess(activityId));
                return true;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(deleteActivityFail(message));
                handleErrorResponse(error, dispatch);
                return false;
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var updateActivity = function updateActivity(activityId, activity) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(dispatch) {
      var updateActivitySuccess, updateActivityRequest, updateActivityFail;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              updateActivitySuccess = sessionActionCreators.updateActivitySuccess, updateActivityRequest = sessionActionCreators.updateActivityRequest, updateActivityFail = sessionActionCreators.updateActivityFail;
              dispatch(updateActivityRequest());
              return _context3.abrupt("return", sessionService.updateActivity(activityId, activity).then(function (a) {
                dispatch(updateActivitySuccess(activity));
                return a;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateActivityFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var clearSessionErrors = function clearSessionErrors() {
  return function (dispatch) {
    var clearSessionErrorsAction = sessionActionCreators.clearSessionErrors;
    dispatch(clearSessionErrorsAction());
  };
};
export var setSessionInfo = function setSessionInfo(info) {
  return function (dispatch) {
    var setSessionInfoAction = sessionActionCreators.setSessionInfo;
    dispatch(setSessionInfoAction(info));
  };
};
export var clearSessionInfo = function clearSessionInfo() {
  return function (dispatch) {
    var clearSessionInfoAction = sessionActionCreators.clearSessionInfo;
    dispatch(clearSessionInfoAction());
  };
};
export var setActivityLocation = function setActivityLocation(location) {
  return function (dispatch) {
    var setActivityLocationAction = sessionActionCreators.setActivityLocation;
    dispatch(setActivityLocationAction(location));
  };
};
export var getActivities = function getActivities(payload) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch) {
      var getActivitiesRequest, getActivitiesSuccess, getActivitiesFail;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              getActivitiesRequest = sessionActionCreators.getActivitiesRequest, getActivitiesSuccess = sessionActionCreators.getActivitiesSuccess, getActivitiesFail = sessionActionCreators.getActivitiesFail;
              dispatch(getActivitiesRequest(payload));
              return _context4.abrupt("return", sessionService.getActivities(payload).then(function (activities) {
                dispatch(getActivitiesSuccess(activities));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getActivitiesFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};
export var createSession = function createSession(payload) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(dispatch) {
      var createSessionRequest, createSessionSuccess, createSessionFail;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              createSessionRequest = sessionActionCreators.createSessionRequest, createSessionSuccess = sessionActionCreators.createSessionSuccess, createSessionFail = sessionActionCreators.createSessionFail;
              dispatch(createSessionRequest());
              return _context5.abrupt("return", sessionService.createSession(payload).then(function (session) {
                dispatch(createSessionSuccess(session));
                return session;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(createSessionFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function (_x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
export var getActivity = function getActivity(activityId) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(dispatch) {
      var getActivityRequest, getActivitySuccess, getActivityFail;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              getActivityRequest = sessionActionCreators.getActivityRequest, getActivitySuccess = sessionActionCreators.getActivitySuccess, getActivityFail = sessionActionCreators.getActivityFail;
              dispatch(getActivityRequest());
              return _context6.abrupt("return", sessionService.getActivity(activityId).then(function (activity) {
                dispatch(getActivitySuccess(activity));
                return activity;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getActivityFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x6) {
      return _ref6.apply(this, arguments);
    };
  }();
};
export var getSession = function getSession(sessionId) {
  return /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(dispatch) {
      var getSessionRequest, getSessionSuccess, getSessionFail;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              getSessionRequest = sessionActionCreators.getSessionRequest, getSessionSuccess = sessionActionCreators.getSessionSuccess, getSessionFail = sessionActionCreators.getSessionFail;
              dispatch(getSessionRequest());
              return _context7.abrupt("return", sessionService.getSession(sessionId).then(function (session) {
                dispatch(getSessionSuccess(session));
                return session;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getSessionFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x7) {
      return _ref7.apply(this, arguments);
    };
  }();
};
export var getSessionAccess = function getSessionAccess(sessionId) {
  return /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(dispatch) {
      var getSessionAccessRequest, getSessionAccessSuccess, getSessionAccessFail;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              getSessionAccessRequest = sessionActionCreators.getSessionAccessRequest, getSessionAccessSuccess = sessionActionCreators.getSessionAccessSuccess, getSessionAccessFail = sessionActionCreators.getSessionAccessFail;
              dispatch(getSessionAccessRequest());
              return _context8.abrupt("return", sessionService.getSessionAccess(sessionId).then(function (entitlementCheck) {
                dispatch(getSessionAccessSuccess(entitlementCheck));
                return entitlementCheck;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getSessionAccessFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    return function (_x8) {
      return _ref8.apply(this, arguments);
    };
  }();
};
export var updateSession = function updateSession(serviceId, sessionId, payload) {
  return /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(dispatch) {
      var updateSessionRequest, updateSessionSuccess, updateSessionFail;
      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              updateSessionRequest = sessionActionCreators.updateSessionRequest, updateSessionSuccess = sessionActionCreators.updateSessionSuccess, updateSessionFail = sessionActionCreators.updateSessionFail;
              dispatch(updateSessionRequest());
              return _context9.abrupt("return", sessionService.updateSession(serviceId, sessionId, payload).then(function (session) {
                dispatch(updateSessionSuccess(session));
                return session;
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(updateSessionFail(message));
                handleErrorResponse(error, dispatch);
                return null;
              }));

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function (_x9) {
      return _ref9.apply(this, arguments);
    };
  }();
};
export var getUpcomingSessions = function getUpcomingSessions(userId) {
  return /*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(dispatch) {
      var getUpcomingSessionsRequest, getUpcomingSessionsSuccess, getUpcomingSessionsFail;
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              getUpcomingSessionsRequest = sessionActionCreators.getUpcomingSessionsRequest, getUpcomingSessionsSuccess = sessionActionCreators.getUpcomingSessionsSuccess, getUpcomingSessionsFail = sessionActionCreators.getUpcomingSessionsFail;
              dispatch(getUpcomingSessionsRequest());
              return _context10.abrupt("return", sessionService.getUpcomingSessions(userId).then(function (sessions) {
                dispatch(getUpcomingSessionsSuccess(sessions));
              }, function (error) {
                var message = getErrorMessageFromErrorResponse(error);
                dispatch(getUpcomingSessionsFail(message));
                handleErrorResponse(error, dispatch);
              }));

            case 3:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    return function (_x10) {
      return _ref10.apply(this, arguments);
    };
  }();
};
export var setCurrentSession = function setCurrentSession(event) {
  return function (dispatch) {
    var setCurrentSessionAction = sessionActionCreators.setCurrentSession;
    dispatch(setCurrentSessionAction(event));
  };
};